/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_S2Inputs */

const en_tut_tampilan_s2 = /** @type {(inputs: Tut_Tampilan_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a **Mode warna**: **Terang**, **Gelap**, or **Ikuti perangkat**.`)
};

const id_tut_tampilan_s2 = /** @type {(inputs: Tut_Tampilan_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih **Mode warna**: **Terang**, **Gelap**, atau **Ikuti perangkat**.`)
};

/**
* | output |
* | --- |
* | "Pick a **Mode warna**: **Terang**, **Gelap**, or **Ikuti perangkat**." |
*
* @param {Tut_Tampilan_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_s2 = /** @type {((inputs?: Tut_Tampilan_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_s2(inputs)
	return en_tut_tampilan_s2(inputs)
});